import { Select as AntdSelect } from 'antd'
import type { SelectProps as AntdSelectProps } from 'antd/es/select'
import { MinusIcon } from 'lucide-react'

import { cn } from '@/lib/ui/style-helpers'

export const ReadOnlyMultiSelect = <ValueType,>({
  value,
  className,
  popupClassName,
  ...props
}: AntdSelectProps<ValueType>) => {
  const isEmpty = !Array.isArray(value) || value.length === 0
  return (
    <div className='relative'>
      <AntdSelect
        {...props}
        value={value}
        placeholder=''
        variant='borderless'
        suffixIcon={null}
        open={false}
        onDropdownVisibleChange={() => false}
        className={cn('pointer-events-none', className)}
        popupClassName={cn('z-max', popupClassName)}
      />
      {isEmpty && (
        <MinusIcon className='pointer-events-none absolute left-0 top-1/2 size-4 -translate-y-1/2 text-main-foreground-primary text-body-default' />
      )}
    </div>
  )
}
